var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.082 5.255a.946.946 0 0 0 1.624.659l2.17-2.169v13.798a.947.947 0 1 0 1.891 0V3.745l2.169 2.169a.946.946 0 1 0 1.338-1.338L5.49.793a.946.946 0 0 0-1.338 0L.368 4.576a.946.946 0 0 0-.286.68Zm8.514 8.522c.007.246.11.48.286.65l3.784 3.784a.946.946 0 0 0 1.337 0l3.784-3.783a.944.944 0 0 0 .014-1.352.944.944 0 0 0-1.351.014l-2.17 2.169V1.46a.946.946 0 1 0-1.891 0V15.26l-2.17-2.17a.946.946 0 0 0-1.623.688Z",
    fill: "#fff"
  })));
};

export default SvgArrows;